import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../services/FormService';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-allow-download',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox
  ],
  template: `
    <div class="form-row">
      <label>
        {{Yii.t('app', 'Allow to download pdf on the FE')}}
      </label>
      <div>
        <p-checkbox
          [(ngModel)]="fsvc.form_json.allowToDownloadPdfOnFE"
          binary="true"
          (change)="onAllowDownloadChange()"/>
      </div>
    </div>

    @if (fsvc.form.allowToDownloadPdfOnFE) {
      <div class="form-row">
        <label>
          {{Yii.t('app', 'Allow to download only digitally signed copy')}}
        </label>
        <div>
          <p-checkbox [(ngModel)]="fsvc.form.allowToDownloadOnlyDigitallySigned" binary="true"/>
        </div>
      </div>
    }
  `
})
export class FormAllowDownloadComponent {
  Yii = Yii;

  constructor(public fsvc: FormService) {}

  onAllowDownloadChange(): void {
    if (!this.fsvc.form.allowToDownloadPdfOnFE) {
      this.fsvc.form.allowToDownloadOnlyDigitallySigned = false;
    }
  }
}
